import { Bold32, Bold24, Medium16, Bold22, Bold18, Medium14, Medium18, Bold12, Bold14, Medium12, Bold16, Regular12 } from './textStyle-legacy-tokens.js';
import { LineHeights, LetterSpacings, LineBreakModes, Alignments } from '../typography/typography-tokens.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* eslint-enable no-unused-vars */

var ButtonSmall = _objectSpread({}, Bold14);
var ButtonMedium = _objectSpread({}, Bold16);
var ButtonLarge = _objectSpread({}, Bold18);
var ButtonXLarge = _objectSpread({}, Bold24);
var MajorPageTitle = _objectSpread(_objectSpread({}, Bold32), {}, {
  color: 'TextPrimary'
});
var PageTitle = _objectSpread(_objectSpread({}, Bold24), {}, {
  color: 'TextPrimary'
});
var PageDescriptionBody = _objectSpread(_objectSpread({}, Medium16), {}, {
  lineHeight: LineHeights.Medium,
  color: 'TextTertiary'
});
var PageSubtext = _objectSpread(_objectSpread({}, Medium16), {}, {
  color: 'TextTertiary'
});
var SectionTitleLarge = _objectSpread(_objectSpread({}, Bold22), {}, {
  color: 'TextPrimary'
});
var SectionTitle = _objectSpread(_objectSpread({}, Bold18), {}, {
  color: 'TextPrimary'
});
var SectionSubtext = _objectSpread(_objectSpread({}, Medium14), {}, {
  color: 'TextTertiary'
});
var ContentBody = _objectSpread(_objectSpread({}, Medium16), {}, {
  lineHeight: LineHeights.Medium,
  color: 'TextTertiary'
});
var ContentAction = _objectSpread(_objectSpread({}, Medium16), {}, {
  color: 'TextAction'
});
var ContentActionDisabled = _objectSpread(_objectSpread({}, Medium16), {}, {
  color: 'TextTertiary'
});
var NavBarAction = _objectSpread(_objectSpread({}, Medium18), {}, {
  color: 'TextAction'
});
var NavBarActionDisabled = _objectSpread(_objectSpread({}, Medium18), {}, {
  color: 'TextTertiary'
});
var NavBarTitle = _objectSpread(_objectSpread({}, Bold18), {}, {
  color: 'TextPrimary'
});
var SmallLabel = _objectSpread(_objectSpread({}, Bold12), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextPrimary'
});
var SmallCalloutLabel = _objectSpread(_objectSpread({}, Bold12), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextCallout'
});
var SmallHighlightLabel = _objectSpread(_objectSpread({}, Bold12), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextHighlight'
});
var Label = _objectSpread(_objectSpread({}, Bold14), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextPrimary'
});
var CalloutLabel = _objectSpread(_objectSpread({}, Bold14), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextCallout'
});
var HighlightLabel = _objectSpread(_objectSpread({}, Bold14), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextHighlight'
});
var ListRowTitleLarge = _objectSpread(_objectSpread({}, Bold18), {}, {
  overflow: LineBreakModes.Truncate
});
var ListRowSubtextLarge = _objectSpread(_objectSpread({}, Medium14), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextTertiary'
});
var ListRowSecondaryLarge = _objectSpread(_objectSpread({}, Medium18), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextTertiary'
});
var ListRowTitle = _objectSpread(_objectSpread({}, Medium16), {}, {
  overflow: LineBreakModes.Truncate
});
var ListRowSubtext = _objectSpread(_objectSpread({}, Medium12), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextTertiary'
});
var ListRowSecondary = _objectSpread(_objectSpread({}, Medium16), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextTertiary'
});
var ListRowTitleLargeSelected = _objectSpread(_objectSpread({}, Bold18), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextSelected'
});
var ListRowSubtextLargeSelected = _objectSpread(_objectSpread({}, Medium14), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextSelected'
});
var ListRowSecondaryLargeSelected = _objectSpread(_objectSpread({}, Medium18), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextSelected'
});
var ListRowTitleSelected = _objectSpread(_objectSpread({}, Medium16), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextSelected'
});
var ListRowSubtextSelected = _objectSpread(_objectSpread({}, Medium12), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextSelected'
});
var ListRowSecondarySelected = _objectSpread(_objectSpread({}, Medium16), {}, {
  overflow: LineBreakModes.Truncate,
  color: 'TextSelected'
});
var SearchBarPlaceholder = _objectSpread(_objectSpread({}, Medium18), {}, {
  color: 'TextPrimary'
});
var SearchBarText = _objectSpread(_objectSpread({}, Medium18), {}, {
  color: 'TextPrimary'
});
var ControlLabel = _objectSpread({}, Bold16);
var TextFieldLabel = _objectSpread(_objectSpread({}, Bold16), {}, {
  letterSpacing: LetterSpacings.Normal,
  color: 'TextPrimary'
});
var TextFieldText = _objectSpread(_objectSpread({}, Medium16), {}, {
  color: 'TextPrimary'
});
var TextFieldPlaceholder = _objectSpread(_objectSpread({}, Medium16), {}, {
  color: 'TextTertiary'
});
var AlertTitle = _objectSpread(_objectSpread({}, Medium18), {}, {
  textAlign: Alignments.Center
});
var AlertText = _objectSpread(_objectSpread({}, Medium14), {}, {
  textAlign: Alignments.Center,
  lineHeight: LineHeights.Medium,
  color: 'TextTertiary'
});
var AlertAction = _objectSpread(_objectSpread({}, Medium18), {}, {
  color: 'TextAction',
  textAlign: Alignments.Center
});
var PrimaryButtonText = _objectSpread(_objectSpread({}, Medium18), {}, {
  color: 'ButtonPrimaryForeground',
  textAlign: Alignments.Center
});
var LegalText = _objectSpread(_objectSpread({}, Regular12), {}, {
  color: 'TextPrimary'
});
var LegalTextMedium = _objectSpread(_objectSpread({}, Medium12), {}, {
  color: 'TextPrimary'
});
var TooltipText = _objectSpread(_objectSpread({}, Medium14), {}, {
  color: 'TooltipInformationalForeground'
});
var TextStyleLegacySemanticsAll = {
  ButtonSmall: ButtonSmall,
  ButtonMedium: ButtonMedium,
  ButtonLarge: ButtonLarge,
  ButtonXLarge: ButtonXLarge,
  MajorPageTitle: MajorPageTitle,
  PageTitle: PageTitle,
  PageDescriptionBody: PageDescriptionBody,
  PageSubtext: PageSubtext,
  SectionTitleLarge: SectionTitleLarge,
  SectionTitle: SectionTitle,
  SectionSubtext: SectionSubtext,
  ContentBody: ContentBody,
  ContentAction: ContentAction,
  ContentActionDisabled: ContentActionDisabled,
  NavBarAction: NavBarAction,
  NavBarActionDisabled: NavBarActionDisabled,
  NavBarTitle: NavBarTitle,
  SmallLabel: SmallLabel,
  SmallCalloutLabel: SmallCalloutLabel,
  SmallHighlightLabel: SmallHighlightLabel,
  Label: Label,
  CalloutLabel: CalloutLabel,
  HighlightLabel: HighlightLabel,
  ListRowTitleLarge: ListRowTitleLarge,
  ListRowSubtextLarge: ListRowSubtextLarge,
  ListRowSecondaryLarge: ListRowSecondaryLarge,
  ListRowTitle: ListRowTitle,
  ListRowSubtext: ListRowSubtext,
  ListRowSecondary: ListRowSecondary,
  ListRowTitleLargeSelected: ListRowTitleLargeSelected,
  ListRowSubtextLargeSelected: ListRowSubtextLargeSelected,
  ListRowSecondaryLargeSelected: ListRowSecondaryLargeSelected,
  ListRowTitleSelected: ListRowTitleSelected,
  ListRowSubtextSelected: ListRowSubtextSelected,
  ListRowSecondarySelected: ListRowSecondarySelected,
  SearchBarPlaceholder: SearchBarPlaceholder,
  SearchBarText: SearchBarText,
  ControlLabel: ControlLabel,
  TextFieldLabel: TextFieldLabel,
  TextFieldText: TextFieldText,
  TextFieldPlaceholder: TextFieldPlaceholder,
  AlertTitle: AlertTitle,
  AlertText: AlertText,
  AlertAction: AlertAction,
  PrimaryButtonText: PrimaryButtonText,
  LegalText: LegalText,
  LegalTextMedium: LegalTextMedium,
  TooltipText: TooltipText
};

export { AlertAction, AlertText, AlertTitle, ButtonLarge, ButtonMedium, ButtonSmall, ButtonXLarge, CalloutLabel, ContentAction, ContentActionDisabled, ContentBody, ControlLabel, HighlightLabel, Label, LegalText, LegalTextMedium, ListRowSecondary, ListRowSecondaryLarge, ListRowSecondaryLargeSelected, ListRowSecondarySelected, ListRowSubtext, ListRowSubtextLarge, ListRowSubtextLargeSelected, ListRowSubtextSelected, ListRowTitle, ListRowTitleLarge, ListRowTitleLargeSelected, ListRowTitleSelected, MajorPageTitle, NavBarAction, NavBarActionDisabled, NavBarTitle, PageDescriptionBody, PageSubtext, PageTitle, PrimaryButtonText, SearchBarPlaceholder, SearchBarText, SectionSubtext, SectionTitle, SectionTitleLarge, SmallCalloutLabel, SmallHighlightLabel, SmallLabel, TextFieldLabel, TextFieldPlaceholder, TextFieldText, TextStyleLegacySemanticsAll, TooltipText, TextStyleLegacySemanticsAll as default };
